<template>
  <div id="bto-design-customize-parts">
    <ul>
      <li
        v-for="(size, key) in idHolder"
        :key="key"
        v-show="key == 'size_' + currentSizeId"
        class="sized-parts-box"
      >
        <ul :style="getAccessorySyzeStyle(key)" class="parts-box">
          <li
            v-for="(beads, k) in size"
            :id="key + '_' + k"
            :key="k"
            class="parts-position"
            :style="getPartsPosition(key, k)"
          >
            <label :for="key + '_' + k + 'i'">
              <button
                @click="beChanged(key, k)"
                :disabled="isActiveHolder(key, k)"
                class="selected-parts-image"
                :style="getPartsStyle(key, k)"
              >
                <picture v-if="usePicture">
                  <source
                    type="image/webp"
                    :srcset="getPartsImageURL(key, k, beads, 'webp')"
                  />
                  <img
                    :src="getPartsImageURL(key, k, beads)"
                    :alt="'Parts ' + k"
                    :style="getPartsImageStyle(key, k, 'img')"
                  />
                </picture>
                <span
                  v-else
                  :style="
                    getPartsImageStyle(key, k, 'span') +
                    ' background-image: url(' +
                    getPartsImageURL(key, k, beads) +
                    ');'
                  "
                ></span>
              </button>
            </label>
            <input
              type="checkbox"
              :id="key + '_' + k + 'i'"
              :style="getCheckBoxPosition(key, k)"
              :disabled="isActiveHolder(key, k)"
              v-if="!isActiveHolder(key, k)"
              :value="key + '-' + k"
              v-model.lazy="partsIsChecked"
              @change="updateSelectedPartsTypes({ key, k }, $event)"
            />
          </li>
        </ul>
        <h3 :style="'width: ' + getAccessorySyze(key) + 'px;'">
          {{ accessoryTitle(key) }}
        </h3>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import accessoryItemRestRepository from "@/mixins/BtoPanel/RepositoryAccessoryItemRest.js";

export default {
  name: "DesignCustomizeParts",

  mixins: [accessoryItemRestRepository],

  props: {
    jewelleryItemId: {
      type: String,
    },
    jewelleryItemCode: {
      type: String,
    },
    jewelleryTypeName: {
      type: String,
    },
    typeArrange: {
      type: Object,
    },
    defaultPartsTypes: {
      type: Object,
    },
    designId: {
      type: Object,
    },
    sizeNameList: {
      type: Object,
    },
    coordinate: {
      type: Object,
    },
    partsInfo: {
      type: Object,
    },
    assetsRoute: {
      type: String,
    },
    usePicture: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      defaultAccessoryWidth: 400,
      checkParts: [],
      checkPartsAll: [],
      checkPartsPreset: [],
    };
  },

  computed: {
    partsIsChecked: {
      get() {
        return this.checkParts;
      },
      set(value) {
        this.checkParts = value;
      },
    },

    ...mapState({
      idHolder: (state) => state.id_holder,
      currentSizeId: (state) => state.current_size_id,
      selectedArrangeType: (state) => state.selectedArrangeType,
    }),
  },

  watch: {
    /**
     * お勧め選択のボタンが押された時、対応する配置を選択する
     */
    selectedArrangeType() {
      this.switchRecommendedSelectPosition(this.selectedArrangeType);
    },

    /**
     * 商品情報取得後にパーツ配置情報を初期化
     * @return {void} [description]
     */
    jewelleryItemId() {
      this.setCheckPartsAll();
    },
  },

  methods: {
    /**
     * サイズキーを渡して、Coordinateデータからアクセサリ幅を返す
     * @param  {String} key [サイズキー]
     * @return {Number}     [アクセサリ幅]
     */
    getAccessorySyze(key) {
      return this.coordinate[key]
        ? this.coordinate[key].ulWidth
        : this.defaultAccessoryWidth;
    },

    /**
     * サイズキーを渡して、.parts-boxのCSSを返す
     * @param  {[String]} key [サイズキー]
     * @return {[String]}     [CSS]
     */
    getAccessorySyzeStyle(key) {
      let size = this.getAccessorySyze(key);
      //let size = 300
      return "width: " + size + "px; height: " + size + "px;";
    },

    /**
     * サイズキーと配置キーを渡して、.parts-positionのCSSを返す
     * @param  {[String]} key [サイズキー]
     * @param  {[String]} k   [配置キー]
     * @return {[String]}     [CSS]
     */
    getPartsPosition(key, k) {
      let x = this.coordinate[key].parts_data[k].ix;
      let y = this.coordinate[key].parts_data[k].iy;
      if ("3" === this.coordinate[key].parts_data[k].type_code) {
        y = y - 2;
      }
      return " top: " + y + "px; left: " + x + "px;";
    },

    /**
     * サイズキーと配置キーで、Coordinateデータからtype_codeを返す
     */
    getTypeCode(key, k) {
      return this.coordinate[key].parts_data[k]["type_code"];
    },

    /**
     * サイズキーと配置キーで、パーツを置き換える機能
     */
    beChanged(key, k) {
      let type_code = new RegExp("bt_" + this.getTypeCode(key, k));
      let parts = this.partsInfo[this.$store.state.current_parts_id];
      if (type_code.test(parts.beadTypes)) {
        this.update_selected_parts_id({ key, k });
        this.delayUpdateBtoResult();
      }
    },

    /**
     * 配置箇所が変更可能かどうか調べる機能
     * @param  {string} key サイズキー
     * @param  {string} k   配置キー
     * @return {Boolean}     [description]
     */
    isActiveHolder(key, k) {
      if ("0" === this.typeArrange[key][k][1]) {
        return true;
      } else {
        return this.coordinate[key].parts_data[k]["disabled"];
      }
    },

    /**
     * サイズキーと配置キーを渡して、Coordinateデータからパーツ幅を返す
     * @param  {[type]} key [サイズキー]
     * @param  {[type]} k   [配置キー]
     * @return {[type]}     [パーツ幅]
     */
    getPartsSize(key, k) {
      let size = this.coordinate[key].parts_data[k].size;
      return size;
    },

    /**
     * サイズキーと配置キーを渡して、Coordinateデータからパーツ丈を返す
     * @param  {[type]} key [サイズキー]
     * @param  {[type]} k   [配置キー]
     * @return {[type]}     [パーツ丈]
     */
    getPartsSizeY(key, k) {
      return this.coordinate[key].parts_data[k].size_y;
    },

    /**
     * サイズキーと配置キーを渡して、.selected-parts-imageのCSSを返す
     * @param  {[type]} key [サイズキー]
     * @param  {[type]} k   [配置キー]
     * @return {[type]}     [CSS]
     */
    getPartsStyle(key, k) {
      let size = this.getPartsSize(key, k);
      let size_y = this.getPartsSizeY(key, k)
        ? this.getPartsSizeY(key, k)
        : size;
      return "width: " + size + "px; height: " + size_y + "px;";
    },

    /**
     * サイズキーと配置キーとパーツIDを渡して、パーツ画像のURLを返す
     * @param  {[type]} key [description]
     * @param  {[type]} k   [description]
     * @param  {[type]} id  [description]
     * @param  {String} imageType
     * @return {[type]}     [description]
     */
    getPartsImageURL(key, k, id, imageType = "") {
      let field = this.coordinate[key].parts_data[k].field;

      let dir =
        "webp" === imageType ? "lit_item_cache/parts/" : "jewelbox/img/";

      let suffix = "webp" === imageType ? "r.webp" : "r.png";

      return (
        this.assetsRoute + dir + id.padStart(3, "0") + "_" + field + suffix
      );
    },

    /**
     * サイズキーと配置キーを渡して、パーツ位置のオフセットCSSを返す
     * @param  {[type]} key [description]
     * @param  {[type]} k   [description]
     * @param  {String} cssType
     * @return {[type]}     [description]
     */
    getPartsImageStyle(key, k, cssType) {
      let offset = this.coordinate[key].parts_data[k].offset;

      if ("img" === cssType) {
        return " transform: translate(-" + offset + "px, 0px);";
      } else {
        return " background-position: top 0px left -" + offset + "px;";
      }
    },

    /**
     * サイズキーと配置キーを渡して、.checkboxのCSSを返す
     * @param  {[type]} key [description]
     * @param  {[type]} k   [description]
     * @return {[type]}     [description]
     */
    getCheckBoxPosition(key, k) {
      let x = this.coordinate[key].parts_data[k].ixi;
      let y = this.coordinate[key].parts_data[k].iyi;
      return " top: " + (y - 2) + "px; left: " + (x - 1) + "px;";
    },

    /**
     * サイズキーと配置キーで、キーリストから、タイプコードとアレンジコードの配列を返す
     * @param  {string} key サイズキー
     * @param  {string} k   配置キー
     * @return {array}     [0]タイプコードと[1]アレンジコード
     */
    getPartsType(key, k) {
      return this.typeArrange[key][k];
    },

    /**
     * 選択箇所をすべて解除する機能
     */
    resetSelectedPartsTypes() {
      this.partsIsChecked = [];
      this.$store.commit("reset_selected_parts_position");
      this.update_selected_parts_types(this.typeArrange);
      this.update_selected_parts_class(this.defaultPartsTypes);
    },

    /**
     * サイズキーと配置キーで、ストラップパーツを判定する
     * @return {Boolean}     [description]
     */
    isStrapParts(key, k) {
      return "f" == this.typeArrange[key][k][0]
        ? true
        : "e" == this.typeArrange[key][k][0]
        ? true
        : false;
    },

    /**
     * 配置箇所がすべて選択された場合のデータを作成
     */
    setCheckPartsAll() {
      if (this.checkPartsAll.length == 0) {
        let arr = [];
        let preset = [];
        let id = null;
        for (let key in this.idHolder) {
          for (let k in this.idHolder[key]) {
            if (!this.isActiveHolder(key, k)) {
              if (!this.isStrapParts(key, k)) {
                arr.push(key + "-" + k);
              }

              id = this.typeArrange[key][k][1];
              if (!Array.isArray(preset[id])) {
                preset[id] = [];
              }
              preset[id].push(key + "-" + k);
            }
          }
        }
        this.checkPartsAll = arr;
        this.checkPartsPreset = preset;
      }
    },

    /**
     * 選択中のパーツタイプをすべて更新する機能
     */
    updateAllSelectedPartsTypes(checked) {
      if (this.checkParts.length) {
        this.checkParts.forEach((position) => {
          let data = position.split("-");
          let key = data[0];
          let k = data[1];
          let keys = { key, k };
          this.update_selected_parts_position({ keys, checked });
        });
      }
    },

    /**
     * vuex状態の一括更新
     * @type {[Void]}
     */
    updateSelectState(checkAll = false, isChecked = false) {
      if (checkAll) {
        this.setCheckPartsAll();
      }
      if (isChecked) {
        this.partsIsChecked = isChecked;
      }
      this.updateAllSelectedPartsTypes(true);
      this.update_selected_parts_types(this.typeArrange);
      this.update_selected_parts_class(this.defaultPartsTypes);
    },

    /**
     * 規定のデザイン配置を選択する機能
     */
    presetSelectedPartsTypes(key) {
      this.resetSelectedPartsTypes();
      this.updateSelectState(true, this.checkPartsPreset[key]);
    },

    /**
     * すべての配置箇所を選択する機能
     */
    selectAlls() {
      this.updateSelectState(true, this.checkPartsAll);
    },

    /**
     * 選択箇所を反転する機能
     */
    switchSelectedPartsTypes() {
      this.setCheckPartsAll();
      let arr = [];
      let parts = this.partsIsChecked;

      arr = this.checkPartsAll.filter((key) => parts.indexOf(key) == -1);
      this.$store.commit("reset_selected_parts_position");
      this.updateSelectState(false, arr);
    },

    /**
     * $store.state.selected_parts_typesを調べて、ストラップパーツの有無を判定する
     * @return {Boolean}     [description]
     */
    isStrapPartsChecked() {
      let key = Object.keys(this.$store.state.selected_parts_types);
      return key.includes("f") ? true : key.includes("e") ? true : false;
    },

    /**
     * 選択された配置箇所のパーツタイプを更新する機能
     * @param  {Object} keys  サイズキー、配置キー
     * @param  {[type]} event イベントハンドラ
     */
    updateSelectedPartsTypes(keys, event) {
      let checked = event.target.checked;

      let partsType = this.getPartsType(keys.key, keys.k);
      if ("f" == partsType[0] || "e" == partsType[0]) {
        //ストラップパーツが選択されたとき
        this.presetSelectedPartsTypes(partsType[1]);
        checked = true;
      } else if (this.isStrapPartsChecked()) {
        //ストラップパーツが選択状態のとき
        this.resetSelectedPartsTypes();
        this.checkParts = [keys.key + "-" + keys.k];
        checked = true;
      }

      this.update_selected_parts_position({ keys, checked });

      this.update_selected_parts_types(this.typeArrange);

      this.update_selected_parts_class(this.defaultPartsTypes);
    },

    /**
     * サイズキーを渡して、アクセサリタイトルを返す
     * @param  {[type]} key [description]
     * @return {[type]}     [description]
     */
    accessoryTitle(key) {
      return "ブレスレット" == this.jewelleryTypeName
        ? this.jewelleryTypeName + this.sizeNameList[key]
        : this.jewelleryTypeName;
    },

    /**
     * 選択コードを受け取って、対応するパーツ配置を選択する
     * @param  {[String]} code [選択コード]
     * @return {[Void]}      []
     */
    switchRecommendedSelectPosition(code) {
      if (null === code) {
        return;
      }
      switch (code) {
        case "select-alls":
          this.selectAlls();
          break;
        case "select-reverse":
          this.switchSelectedPartsTypes();
          break;
        case "select-clear":
          this.resetSelectedPartsTypes();
          break;
        default:
          this.presetSelectedPartsTypes(code);
      }
      this.updateselectedArrangeType(null);
    },

    ...mapMutations(["updateselectedArrangeType"]),

    ...mapActions([
      "update_selected_parts_position",
      "update_selected_parts_id",
      "update_selected_parts_types",
      "update_selected_parts_class",
      "update_bto_result",
    ]),
  },
};
</script>

<style scoped lang="stylus">
#bto-design-customize-parts
  background-image: url($css-assets bg_bto_designview.jpg)
  background-repeat: repeat;
  ul.parts-box
    background-color: white;
    input[type="checkbox"]
      z-index: 20;

.selected-parts-image
  img
    max-width: none;

@css {
	#bto-design-customize-parts {
    background-color: #efebe3;
    @apply px-2 py-4 text-left mb-4
  }
	#bto-design-customize-parts ul {
    @apply overflow-x-scroll lg:overflow-x-visible flex justify-center
  }
  #bto-design-customize-parts h3 {
    @apply text-right mx-auto my-1
  }
  .sized-parts-position {
  }
  #bto-design-customize-parts .parts-position li {
    @apply inline-block
  }
  .parts-box {
    @apply relative m-auto overflow-hidden
  }
  .parts-position,
  .parts-position input {
    @apply absolute
  }
  .selected-parts-image {
    @apply overflow-hidden focus:outline-none
  }
  .selected-parts-image img {
    @apply pointer-events-none
  }
  .selected-parts-image span {
    @apply w-full h-full block bg-no-repeat
  }
}
</style>
